import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase";
import { reviewsCollectionName } from "./mode";

const COL = "pop_market_reviews";

export async function listReviewsForSeller(handle, max = 20) {
  const q = query(
      collection(db, reviewsCollectionName()),
      where("sellerHandle", "==", handle),
      where("hidden", "==", false),
      orderBy("createdAt", "desc"),
      limit(max),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Server-side: rate-limit (1 review per seller per 90d per reviewer),
// tenure check (≥30 day account), IP-flood detection, captcha verify.
export async function submitReview({ sellerHandle, rating, text, screenshotPath }) {
  return httpsCallable(functions, "popMarketSubmitReview")({
    sellerHandle, rating, text, screenshotPath,
  }).then((r) => r.data);
}

export async function markHelpful(reviewId) {
  return httpsCallable(functions, "popMarketReviewHelpful")({ reviewId })
      .then((r) => r.data);
}

export async function flagReview(reviewId, reason) {
  return httpsCallable(functions, "popMarketReviewFlag")({ reviewId, reason })
      .then((r) => r.data);
}

export async function getOwnReviewForSeller(sellerHandle, reviewerUid) {
  if (!reviewerUid) return null;
  const compositeId = `${sellerHandle}_${reviewerUid}`;
  const snap = await getDoc(doc(db, COL, compositeId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}
